import { API } from "./API";
export const QueryAPI = {
  
    InsertQuery: async (userName, status, type, name, date, parameters, parentId) => {

        let data = JSON.stringify({
            requestValue: {               
                userName : userName,
                status : status,
                type : type,
                name : name,
                date : date,
                requestParameters : parameters,
                parentId : parentId
            },
        })   
        return await API.post(`Query/InsertQuery`, data);
    },

    GetQuery: async (queryId) => {

        let data = JSON.stringify({
            requestValue: {
                queryId: queryId,              
            },
        })
        return await API.post(`Query/GetQuery`, data);
    },

    GetQueries: async (userName) => {

        let data = JSON.stringify({
            requestValue: {
                userName: userName,              
            },
        })
        return await API.post(`Query/GetQueries`, data);
    },

    GetQueryData: async (queryId, queryType) => {

        let data = JSON.stringify({
            requestValue: {
                queryId: queryId,
                queryType : queryType
            },
        })
        return await API.post(`Query/GetQueryData`, data);
    },

    GetReportFromQuery: async (queryId) => {

        let data = JSON.stringify({
            requestValue: {
                queryId: queryId
            },
        })
        return await API.post(`Query/GetReportFromQuery`, data);
    },

    IsExistQuery: async (queryType, userName, requestParameters) => {

        let data = JSON.stringify({
            requestValue: {
                queryType: queryType,
                userName: userName,
                requestParameters : requestParameters
            },
        })
        return await API.post(`Query/IsExistQuery`, data);
    },
    GetQueryStatuses: async (queryId) => {

        let data = JSON.stringify({
            requestValue: {
                queryId: queryId
            },
        })
        return await API.post(`Query/GetQueryStatuses`, data);
    },
}